import { SvrConn } from "../utils/axios/index";

//-------------------
const getMedicoAll = async () => {
  let res = {};
  try 
   {
     res = await SvrConn.get("/api/medico/getmedicoall");
   } 
   catch (Error) 
   {
     res = Error;
   }
  return res;
};

//-------Consulta un medico en un area
const getMedicoInt = async (AreaId, UsuarioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/medico/getmedicoint", {
      AreaId,
      UsuarioId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

const ActualizaMedico = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/medico/setactualizamedico", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};


export {getMedicoAll, getMedicoInt, ActualizaMedico}